import { Button } from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaArrowRotateRight } from 'react-icons/fa6';

import { IndicatorsService } from '@/client';
import { Tooltip } from '@/components/ui/tooltip';
import useCustomToast from '@/hooks/use-custom-toast';
import useMediaQuery from '@/hooks/use-media-query';

export const CollecteRecalculationButton = () => {
  const queryClient = useQueryClient();
  const { slug, year } = useParams({ strict: false });
  const { t } = useTranslation();
  const [refreshLoading, setRefreshLoading] = useState(false);
  const showToast = useCustomToast();

  const refreshHandler = () => {
    setRefreshLoading(true);
    IndicatorsService.recalculateIndicatorYearSettings({
      companySlug: slug,
      year: year,
    }).then(() => {
      setRefreshLoading(false);
      queryClient.invalidateQueries({ queryKey: ['indicators_progression'] });
      queryClient.invalidateQueries({ queryKey: ['indicators_periods'] });
      showToast('Success!', 'Indicator recalculated !', 'success');
    });
  };

  const isTooltipHidden = useMediaQuery('(min-width: 1250px)');

  return (
    <Tooltip
      showArrow
      content={t('collection.refresh')}
      openDelay={100}
      closeDelay={100}
      contentProps={{ css: { '--tooltip-bg': 'colors.primary' } }}
      disabled={isTooltipHidden}
    >
      <Button
        size="sm"
        loading={refreshLoading}
        loadingText={`${t('collection.refresh')}...`}
        onClick={() => refreshHandler()}
        variant={'outline'}
        {...(!isTooltipHidden && { p: '0' })}
      >
        <FaArrowRotateRight />
        {isTooltipHidden && <span>{t('collection.refresh')}</span>}
      </Button>
    </Tooltip>
  );
};
